'use client'

import { useEffect, useState } from 'react'
import { useDemo } from '@/components/demo/DemoProvider'

type SceneInfo = {
  id: string
}

export default function CommunityDemoPlayer() {
  const { state, close } = useDemo()
  const [scene, setScene] = useState<SceneInfo | null>(null)

  useEffect(() => {
    function onSceneStart(event: Event) {
      const customEvent = event as CustomEvent
      setScene({ id: String(customEvent.detail?.sceneId || '') })
    }

    function onFinished() {
      setScene({ id: 'finished' })
    }

    window.addEventListener('community-demo:scene-start', onSceneStart as EventListener)
    window.addEventListener('community-demo:finished', onFinished as EventListener)

    return () => {
      window.removeEventListener('community-demo:scene-start', onSceneStart as EventListener)
      window.removeEventListener('community-demo:finished', onFinished as EventListener)
    }
  }, [])

  if (!state.isOpen || state.scope !== 'community') return null

  return (
    <div className="fixed bottom-6 left-6 z-[10100] w-[360px] rounded-2xl border bg-background p-4 shadow-2xl">
      <div className="text-xs text-muted-foreground">Demo guiado</div>
      <div className="mt-1 text-lg font-semibold">
        {scene?.id === 'finished'
          ? 'Recorrido completado'
          : scene?.id || 'Preparando recorrido...'}
      </div>

      <div className="mt-2 text-sm text-muted-foreground">
        {scene?.id === 'finished'
          ? 'Si quieres volver a ver el recorrido, solo pídeselo a Samantha.'
          : 'Samantha te está mostrando la plataforma paso a paso.'}
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={close}
          className="rounded-lg border px-3 py-2 text-sm"
        >
          Cerrar
        </button>
      </div>
    </div>
  )
}